import React, { useState, useEffect } from "react";
import { Chart } from "react-google-charts";
import { Link, useNavigate, useParams } from "react-router-dom";
import { startOfMonth, endOfMonth, format, addMonths, parse, getYear, setMonth, getMonth, setYear } from 'date-fns';
import { Campaign, useSearchCampaignQueryQuery, useSearchCrmQueryQuery } from "../../generated/graphql";
import { SalesTeamSelect } from "../../components/MaterialSelects/SalesTeamSelect";
import { SelectId } from "../../components/MaterialSelects/SelectId";
import { NonIdealState } from "../../components/NonIdealState";
import { variableCurrencyValue } from "../../components/field-table";
import { ClientSubTypeSelect } from "../../components/MaterialSelects/ClientSubTypeSelect";
import { UserSelect } from "../../components/MaterialSelects/UserSelect";
import { ClientCompanyContactSelect } from "../../components/MaterialSelects/ClientCompanyContactSelect";
import { useUserContext } from "../../contexts/user-context";
import {
    KeyboardArrowLeft,
    KeyboardArrowRight,
    KeyboardDoubleArrowLeft,
    KeyboardDoubleArrowRight
} from "@mui/icons-material";
import { ClientCompanySelect } from "../../components/MaterialSelects/ClientCompanySelect";
import WaitSpinner from "../../components/wait-spinner";
import { Button, IconButton, styled } from "@mui/material";
import { SalesReportTypeSelect } from "../../components/MaterialSelects/SalesReportTypeSelect";
import { asMoney } from "../../utils";
import { FormControlLabel, Switch } from "@mui/material";
import { IsoDatePicker } from "../../components/IsoDatePicker";
import { useSnackbar } from "notistack";

const MonthPicker = (props) => {
    console.log("props.value:", props);
    let i;
    const now = new Date();
    const date = parse(props.value + '-01', 'yyyy-MM-dd', now);
    const month = getMonth(date);
    const year = getYear(date);
    const cy = getYear(now);
    const years = [];
    for (i = cy + 1; i >= 2010; i--) {
        years.push({ id: i, label: i.toString() });
    }
    const months = [];
    const monthLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    for (i = 0; i < 12; i++) {
        months.push({ id: i, label: monthLabels[i] });
    }
    const addMonth = (m) => () => {
        props.onChange({ target: { name: props.name, value: format(addMonths(date, m), 'yyyy-MM') } });
        // do something with quarters here...
    };
    const changeMonth = (m) => {
        props.onChange({ target: { name: props.name, value: format(setMonth(date, m.target.value), 'yyyy-MM') } });
    };
    const changeYear = (m) => {
        props.onChange({ target: { name: props.name, value: format(setYear(date, m.target.value), 'yyyy-MM') } });
    };
    console.log('MONTH', month, year, months);
    return (<div className="month-control">
        <IconButton onClick={addMonth(-12)}><KeyboardDoubleArrowLeft /></IconButton>
        <IconButton onClick={addMonth(-1)}><KeyboardArrowLeft /></IconButton>
        <SelectId labelField="label" minWidth="10rem" simpleSelect={true} valueIsId={true} name="month" onChange={changeMonth} options={months} value={month} label="Month" />
        <SelectId labelField="label" minWidth="10rem" simpleSelect={true} valueIsId={true} name="year" onChange={changeYear} options={years} value={year} label="Year" />
        <IconButton onClick={addMonth(1)}><KeyboardArrowRight /></IconButton>
        <IconButton onClick={addMonth(12)}><KeyboardDoubleArrowRight /></IconButton>
    </div>);
};

function d2(v) {
    if (!v) return '00';
    if (v < 10) { v = '0' + v; }
    return v;
}

const nowT = new Date();
const now = {
    startOfMonth: startOfMonth(nowT),
    year: getYear(nowT),
    month: getMonth(nowT),
    quarter: Math.floor(getMonth(nowT) / 3),
    half: Math.floor(getMonth(nowT) / 6)
};

const statuses = [
    { label: 'Confirmed', id: 'confirmed' },
    { label: 'Draft', id: 'draft', },
    { label: 'Quote', id: 'quote', },
    { label: 'Confirmed and Quote', id: 'confirmed_quote' },
    { label: 'Confirmed, Quote and Draft', id: 'confirmed_quote_draft' }
];

const status_values = {
    'confirmed_quote_draft': ['Paid', 'To invoice', 'Invoiced', 'Confirmed', 'Part Invoiced', 'Quote', 'Draft'],
    'confirmed_quote': ['Paid', 'To invoice', 'Invoiced', 'Confirmed', 'Part Invoiced', 'Quote'],
    'confirmed': ['Paid', 'To invoice', 'Invoiced', 'Confirmed', 'Part Invoiced'],
    'quote': ['Quote'],
    'draft': ['Draft']
};

const quarters = [
    { label: 'Q1', id: 0 },
    { label: 'Q2', id: 1 },
    { label: 'Q3', id: 2 },
    { label: 'Q4', id: 3 }
];

const halves = [
    { label: 'H1', id: 0 },
    { label: 'H2', id: 1 }
];

export default function AccountManagerDashboard() {
    const nowDate = new Date();
    const user = useUserContext();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [formState, setFormState] = useState({
        salesTeam: '',
        accountManager: user.user?.id,
        clientSubType: '',
        contacts: '',
        client: '',
        status: 'confirmed',
        periodType: 'month',
        currentMonthYear: `${now.year}-${d2(now.month + 1)}`,
        currentQuarter: now.quarter.toString(),
        currentYear: now.year.toString(),
        currentHalf: now.half.toString(),
        period: now.year + '-' + now.quarter.toString(),
        toggleTop15Campaigns: true,
        years_comparison: false,
        completion_date: '',
        start_date: ''
    });

    let [variables, setVariables] = useState<{
        sales_team_all: boolean;
        sales_team_core: boolean;
        account_manager_ids: number[];
        completion_date_between?: {
            from: string;
            to: string;
        };
        status_in: string[];
    }>({
        sales_team_all: true,
        sales_team_core: false,
        account_manager_ids: [user.user?.id],
        completion_date_between: {
            from: formState.currentMonthYear + '-01',
            to: format(endOfMonth(parse(formState.currentMonthYear + '-01', 'yyyy-MM-dd', nowDate)), 'yyyy-MM-dd')
        },
        status_in: [
            "Paid",
            "To invoice",
            "Invoiced",
            "Confirmed",
            "Part Invoiced"
        ]
    });

    const handleFormStateChange = (name, value) => {
        let updatedState = { ...formState, [name]: value };
        let newVariables = { ...variables };
        let from = null, to = null;

        if (formState.periodType === 'month') {
            if (name === 'currentMonthYear') {
                updatedState.period = value;
                updatedState.currentYear = value.split("-")[0];
            }
        } else if (formState.periodType === 'quarter') {
            if (name === 'currentQuarter' || name === 'currentYear') {
                updatedState.period = `${updatedState.currentYear}-${updatedState.currentQuarter}`;
            }
        } else if (formState.periodType === 'half') {
            if (name === 'currentHalf' || name === 'currentYear') {
                updatedState.period = `${updatedState.currentYear}-${updatedState.currentHalf}`;
            }
        } else if (formState.periodType === 'year') {
            if (name === 'currentYear') {
                updatedState.period = value;
            }
        }
        console.log("[Updated State]", updatedState)
        setFormState(updatedState);

        if (updatedState.salesTeam && updatedState.salesTeam.length > 0) {
            newVariables.sales_team_all = false;
            newVariables.sales_team_core = false;
            newVariables.sales_team_ids = updatedState.salesTeam;
        } else {
            newVariables.sales_team_all = true;
            newVariables.sales_team_core = false;
            delete newVariables.sales_team_ids;
        }
        if (updatedState.status) {

            newVariables.status_in = status_values[updatedState.status];
        } else {
            delete newVariables.status_in;
        }
        if (updatedState.accountManager) {
            newVariables.account_manager_ids = [updatedState.accountManager];
        } else {
            delete newVariables.account_manager_ids;
        }
        if (updatedState.clientSubType) {
            newVariables.client_sub_type_ids = [updatedState.clientSubType];
        } else {
            delete newVariables.client_sub_type_ids;
        }
        if (updatedState.contacts) {
            newVariables.contact_ids = [updatedState.contacts];
        } else {
            delete newVariables.contact_ids;
        }
        if (updatedState.client && updatedState.client.length > 0) {
            newVariables.client_ids = updatedState.client;
        } else {
            delete newVariables.client_ids;
        }
        if (updatedState.years_comparison) {
            delete newVariables.completion_date_between;
            let currentYear = parseInt(updatedState.currentYear, 10);
            const lastTwoYears = [currentYear - 2, currentYear - 1, currentYear];

            switch (updatedState.periodType) {
                case 'month':
                    const [yearPart, monthPart] = updatedState.currentMonthYear.split("-");
                    newVariables.completion_date_in = lastTwoYears.map(year => ({
                        from: `${year}-${monthPart}-01`,
                        to: format(endOfMonth(parse(`${year}-${monthPart}-01`, 'yyyy-MM-dd', new Date())), 'yyyy-MM-dd')
                    }));
                    break;

                case 'quarter':
                    const quarterIdx = parseInt(updatedState.currentQuarter, 10);
                    const startMonthOfQuarter = quarterIdx * 3 + 1;

                    newVariables.completion_date_in = lastTwoYears.map(year => ({
                        from: `${year}-${d2(startMonthOfQuarter)}-01`,
                        to: format(endOfMonth(parse(`${year}-${d2(startMonthOfQuarter + 2)}-01`, 'yyyy-MM-dd', new Date())), 'yyyy-MM-dd')
                    }));
                    break;

                case 'half':
                    const halfIdx = parseInt(updatedState.currentHalf, 10);
                    const firstMonthOfHalf = d2((halfIdx * 6) + 1);

                    newVariables.completion_date_in = lastTwoYears.map(year => ({
                        from: `${year}-${firstMonthOfHalf}-01`,
                        to: format(endOfMonth(parse(`${year}-${d2((halfIdx + 1) * 6)}-01`, 'yyyy-MM-dd', new Date())), 'yyyy-MM-dd')
                    }));
                    break;

                case 'year':
                    delete newVariables.completion_date_in;
                    const toDate = parse(`${currentYear}-12-01`, 'yyyy-MM-dd', new Date());

                    newVariables.completion_date_between = {
                        from: `${currentYear - 2}-01-01`,
                        to: format(endOfMonth(toDate), 'yyyy-MM-dd'),
                    };
                    break;

                case 'range':
                    if (updatedState.start_date && updatedState.completion_date && updatedState.client.length > 0) {
                        newVariables.completion_date_between = {
                            from: updatedState.start_date,
                            to: updatedState.completion_date
                        };
                    } else {
                        enqueueSnackbar("Please select a client and both start and end dates for the range period.", {
                            variant: 'error'
                        });
                    }
                    break;

                default:
                    newVariables.skip = true;
                    break;
            }
        }

        else {
            delete newVariables.completion_date_in;
            switch (updatedState.periodType) {
                case 'month':
                    newVariables.completion_date_between = {
                        from: updatedState.currentMonthYear + '-01',
                        to: format(endOfMonth(parse(updatedState.currentMonthYear + '-01', 'yyyy-MM-dd', new Date())), 'yyyy-MM-dd')
                    };
                    break;

                case 'quarter':
                    const quarterIdx = parseInt(updatedState.currentQuarter);
                    const quarterYear = updatedState.currentYear;
                    from = parse(quarterYear + '-' + d2((quarterIdx * 3) + 1) + '-01', 'yyyy-MM-dd', new Date());
                    to = parse(quarterYear + '-' + d2((quarterIdx + 1) * 3) + '-01', 'yyyy-MM-dd', new Date());
                    newVariables.completion_date_between = {
                        from: format(from, 'yyyy-MM-dd'),
                        to: format(endOfMonth(to), 'yyyy-MM-dd'),
                    };
                    break;

                case 'half':
                    const halfIdx = parseInt(updatedState.currentHalf);
                    const halfYear = updatedState.currentYear;
                    from = parse(halfYear + '-' + d2((halfIdx * 6) + 1) + '-01', 'yyyy-MM-dd', new Date());
                    to = parse(halfYear + '-' + d2((halfIdx + 1) * 6) + '-01', 'yyyy-MM-dd', new Date());
                    newVariables.completion_date_between = {
                        from: format(from, 'yyyy-MM-dd'),
                        to: format(endOfMonth(to), 'yyyy-MM-dd'),
                    };
                    break;

                case 'year':
                    const currentYear = updatedState.currentYear;
                    from = parse(currentYear + '-01-01', 'yyyy-MM-dd', new Date());
                    to = parse(currentYear + '-12-01', 'yyyy-MM-dd', new Date());
                    newVariables.completion_date_between = {
                        from: format(from, 'yyyy-MM-dd'),
                        to: format(endOfMonth(to), 'yyyy-MM-dd'),
                    };
                    break;
                default:
                    newVariables.skip = true;
                    break;
            }
        }

        console.log("[Updated State] [Final Variables]", newVariables);

        setVariables(newVariables);

    };

    const years = [];
    for (let i = now.year - 5; i < now.year + 5; i++) {
        years.push({ label: i.toString(), id: i });
    }


    const { loading, error, data } = useSearchCrmQueryQuery({
        variables: variables,
        fetchPolicy: 'network-only',
        skip: !!variables?.skip,
    });

    const onChange = (evt) => {
        const { name, type, checked, value } = evt.target;
        const newValue = type === 'checkbox' ? checked : value;
        handleFormStateChange(name, newValue);
    };

    const campaigns = (!loading && !error && data) ? data.campaigns.data : [];

    const renderBodyDashboard = React.useMemo(() => {
        if (error) {
            return <NonIdealState title="An error has occurred" />;
        }

        if (loading) {
            return <WaitSpinner type="fixed" />;
        }

        const revenueBySector = {};
        const revenueByClient = {};
        const revenueByYear = {};
        const revenueByST = {};
        const currentYear = parseInt(formState.currentYear, 10);
        const lastTwoYears = [currentYear - 2, currentYear - 1, currentYear];

        const revenueByCategory = {
            Confirmed: 0,
            Likely: 0,
            Forecast: 0,
            Cancelled: 0
        };

        const statusMapping = {
            Confirmed: ['Paid', 'To invoice', 'Invoiced', 'Confirmed', 'Part Invoiced'],
            Likely: ['Quote'],
            Forecast: ['Draft'],
            Cancelled: ['Cancelled']
        };
        const top15CampaignsData = [];

        const updateRevenueBySalesTeamYearly = (salesTeam, year, revenue) => {
            if (salesTeam && salesTeam.include_dashboard_core) {
                if (!revenueByST[salesTeam.prefix]) {
                    revenueByST[salesTeam.prefix] = {};
                }
                if (!revenueByST[salesTeam.prefix][year]) {
                    revenueByST[salesTeam.prefix][year] = 0;
                }
                revenueByST[salesTeam.prefix][year] += revenue;
            }
        };

        if (campaigns && campaigns.length > 0) {
            campaigns.forEach(campaign => {
                const status = campaign.status;
                const revenue = (campaign.total_price_reporting) / 100;
                const clientType = campaign.clientSubType?.name || 'Unknown';
                const client = campaign.clientCompany?.accounts_company || '';
                const name = campaign.name;
                const year = new Date(campaign.completion_date).getFullYear();
                const salesTeam = campaign.salesTeam || '';

                top15CampaignsData.push({ name: name, revenue });

                // Categorize revenue by status
                for (const [category, statuses] of Object.entries(statusMapping)) {
                    if (statuses.includes(status)) {
                        revenueByCategory[category] += revenue;
                        break;
                    }
                }

                // Aggregate revenue by client type
                if (clientType) {
                    if (!revenueBySector[clientType]) {
                        revenueBySector[clientType] = 0;
                    }
                    revenueBySector[clientType] += revenue;
                }

                // Aggregate revenue by client
                if (client) {
                    if (!revenueByClient[client]) {
                        revenueByClient[client] = 0;
                    }
                    revenueByClient[client] += revenue;
                }

                // Store revenue by year for last two years and the current year
                if (lastTwoYears.includes(year)) {
                    if (!revenueByYear[client]) {
                        revenueByYear[client] = Object.fromEntries(lastTwoYears.map(y => [y, 0]));
                    }
                    revenueByYear[client][year] += revenue;
                }

                // Prepare sales team YoY data only if no specific client is selected
                if (salesTeam) {
                    updateRevenueBySalesTeamYearly(salesTeam, year, revenue);
                }

            });
        }

        const clientYOY = [
            ["Client", ...lastTwoYears.map(year => year.toString())]
        ];
        const salesYOY = [
            ["Sales Team", ...lastTwoYears.map(year => year.toString())]
        ];

        for (const client in revenueByYear) {
            const yearData = revenueByYear[client];

            const revenues = lastTwoYears.map(year => yearData[year] || 0);
            clientYOY.push([client, ...revenues]);
        }

        for (const team in revenueByST) {
            const yearData = revenueByST[team];
            const revenues = lastTwoYears.map(year => yearData[year] || 0);
            salesYOY.push([team, ...revenues]);
        }

        const top15Campaigns = top15CampaignsData.sort((a, b) => b.revenue - a.revenue).slice(0, 15);

        const topCampaignsChartData = [
            ["Campaign", "Revenue"],
            ...top15Campaigns.map(campaign => [campaign.name, campaign.revenue])
        ];
        const chartData = [
            ["Status", "Revenue"],
            ...Object.entries(revenueByCategory).map(([category, revenue]) => [category, revenue])
        ];
        const topFiveSectors = Object.entries(revenueBySector)
            .sort(([, aRevenue], [, bRevenue]) => bRevenue - aRevenue)
            .slice(0, 5);

        const barChartData = [
            ["Sector", "Revenue"],
            ...topFiveSectors.map(([sector, revenue]) => [sector, revenue])
        ];
        const pieChartClient = [
            ["Client", "Revenue"],
            ...Object.entries(revenueByClient)
                .sort(([, aRevenue], [, bRevenue]) => bRevenue - aRevenue)
                .map(([client, revenue]) => [client, revenue])
        ];

        console.log("[Updated State Chart]", revenueByST)
        const totalRevenue = Object.values(revenueByCategory).reduce((sum, revenue) => sum + revenue, 0);
        if (totalRevenue === 0) {
            return <NonIdealState title="No data available for the current search. Please choose different filters to alter the chart." />;
        }
        const colors = [
            "#05c31c", // Confirmed 
            "#FFA500", // Likely 
            "#54d0f8", // Forecast 
            "#FF0000"  // Cancelled
        ];

        return (
            <div className="sales-report__controls__chartsCRM">
                {!formState.years_comparison &&
                    <Chart
                        chartType="PieChart"
                        data={chartData}
                        options={{
                            title: "My Total Revenue",
                            slices: {
                                0: { color: colors[0] },
                                1: { color: colors[1] },
                                2: { color: colors[2] },
                                3: { color: colors[3] }
                            }
                        }}
                        height={"400px"}
                    />
                }
                <Chart
                    chartType="PieChart"
                    data={pieChartClient}
                    options={{
                        title: "Revenue Per Client",
                        is3D: true,
                    }}
                    height={"400px"}
                />
                {formState.toggleTop15Campaigns ? (
                    <div id="topCampaignsChartWrapper">
                        <Chart
                            chartType="Bar"
                            height="400px"
                            data={topCampaignsChartData}
                            options={{
                                chart: {
                                    title: "Top 15 Campaigns by Revenue",
                                    chartArea: { width: "100%" },
                                }
                            }}
                            chartEvents={[
                                {
                                    eventName: "select",
                                    callback: ({ chartWrapper }) => {
                                        const wrapperElement = document.getElementById('topCampaignsChartWrapper');
                                        if (wrapperElement) {
                                            const chart = chartWrapper.getChart();
                                            const selection = chart.getSelection();
                                            if (selection.length > 0) {
                                                const selectedRowIndex = selection[0].row;
                                                const selectedCampaign = top15Campaigns[selectedRowIndex];

                                                if (selectedCampaign) {
                                                    const userConfirmed = confirm("Do you want to open this campaign?");
                                                    if (userConfirmed) {
                                                        window.open(`/campaigns/${selectedCampaign.jobref}`, '_blank');
                                                    }
                                                } else {
                                                    console.error("Campaign not found for the selected row index");
                                                }
                                            } else {
                                                console.error("No chart element selected");
                                            }
                                        }
                                    }
                                }
                            ]}
                        />
                    </div>
                ) : (
                    <Chart
                        chartType="Bar"
                        height="400px"
                        data={barChartData}
                        options={{
                            chart: {
                                title: "Top 5 Sectors",
                                subtitle: "Client Types & Revenue",
                            },
                            hAxis: { title: 'Total Revenue', minValue: 0 },
                            vAxis: { title: 'Sectors' },
                        }}
                    />
                )}
                {formState.years_comparison && (
                    !formState.client || formState.client.length === 0 ? (
                        <Chart
                            chartType="Bar"
                            height="400px"
                            data={salesYOY}
                            options={{
                                chart: {
                                    title: "Sales Team Performance Year over Year",
                                },
                                isStacked: true,
                            }}
                        />
                    ) : (
                        <Chart
                            chartType="Bar"
                            height="400px"
                            data={clientYOY}
                            options={{
                                chart: {
                                    title: "Client Performance",
                                },
                                isStacked: true,
                            }}
                        />
                    )
                )
                }

            </div>

        );
    }, [loading, error, campaigns, formState]);

    const allowedUsers = [
        "Muhammad.ahmed@buildhollywood.co.uk",
        "conor@jackagency.co.uk",
        "jayne@buildhollywood.co.uk",
        "michael@buildhollywood.co.uk",
        "kevin@diabolical.co.uk",
        "emma@buildhollywood.co.uk",
        "kristela@diabolical.co.uk",
        "rebecca@diabolical.co.uk",
        "mia.baker@buildhollywood.co.uk",
        "charlotte@jack-arts.co.uk",
        "amelia@jackagency.co.uk",
        "alisha.dandridge@buildhollywood.co.uk"
    ];
    return (
        <React.Fragment>
            <div className="sales-report__controls">
                {allowedUsers.includes(user.user?.email) && (
                    <>
                        <div>
                            <SalesTeamSelect
                                minWidth="15rem"
                                valueIsId={true}
                                simpleSelect={true}
                                allowBlank={true}
                                multiple={true}
                                blankLabel="All Sales Teams"
                                extraOptions={[{ id: "core", name: "Core Sales Teams" }]}
                                label="Sales Team"
                                value={formState.salesTeam || []}
                                onChange={onChange}
                                name="salesTeam"
                            />
                        </div>
                        <div>
                            <UserSelect
                                valueIsId={true}
                                simpleSelect={true}
                                allowBlank={true}
                                blankLabel="All Account Manager"
                                label="Account Managers"
                                value={formState.accountManager || []}
                                onChange={onChange}
                                name="accountManager"
                            />
                        </div>
                    </>
                )}
                <div className="sales-report__controls__type">
                    <SalesReportTypeSelect valueIsId={true} simpleSelect={true} name="periodType" rangePeriod={false} onChange={onChange} value={formState.periodType} label="Period" />
                </div>

                {formState.periodType === 'month' &&
                    <div className="sales-report__controls__month">
                        <MonthPicker valueIsId={true} value={formState.currentMonthYear} name="currentMonthYear" onChange={onChange} label="Month" /></div>
                }
                {formState.periodType === 'quarter' &&
                    <div className="sales-report__controls__quarter month-control">
                        <SelectId name="currentQuarter" labelField="label" simpleSelect={true} label="Quarter" onChange={onChange} options={quarters} value={formState.currentQuarter} />
                        <SelectId name="currentYear" labelField="label" label="Year" simpleSelect={true} onChange={onChange} options={years} value={formState.currentYear} />
                    </div>
                }
                {formState.periodType === 'half' &&
                    <div className="sales-report__controls__quarter month-control">
                        <SelectId name="currentHalf" labelField="label" label="Half" simpleSelect={true} onChange={onChange} options={halves} value={formState.currentHalf} />
                        <SelectId name="currentYear" labelField="label" label="Year" simpleSelect={true} onChange={onChange} options={years} value={formState.currentYear} />
                    </div>
                }
                {formState.periodType === 'year' &&
                    <div className="sales-report__controls__quarter month-control">
                        <SelectId name="currentYear" label="Year" labelField="label" simpleSelect={true} onChange={onChange} options={years} value={formState.currentYear} />
                    </div>
                }
                {formState.periodType === 'range' && (
                    <>
                        <div className="sales-report__controls__date-range">
                            <IsoDatePicker name="start_date" label="Start Date" onChange={onChange} className="grid12-2" style={{ width: '10rem' }} value={formState.start_date} />
                        </div>
                        <div>
                            <IsoDatePicker name="completion_date" label="Completion Date" onChange={onChange} className="grid12-2" style={{ width: '10rem' }} value={formState.completion_date} />

                        </div>
                    </>
                )}
                <div>
                    <ClientSubTypeSelect
                        valueIsId={true}
                        simpleSelect={true}
                        allowBlank={true}
                        blankLabel="All Client Type"
                        label="Client Types"
                        value={formState.clientSubType || []}
                        onChange={onChange}
                        name="clientSubType"
                    />
                </div>
                <div>
                    <ClientCompanyContactSelect
                        valueIsId={true}
                        allowBlank={true}
                        blankLabel="All Contacts"
                        label="Contact"
                        value={formState.contacts || []}
                        onChange={onChange}
                        name="contacts"
                    />
                </div>
                <div style={{ width: '10rem' }} >
                    <ClientCompanySelect
                        valueIsId={true}
                        multiple={true}
                        allowBlank={true}
                        blankLabel="All Clients"
                        label="Client"
                        value={formState.client || []}
                        onChange={onChange}
                        name="client"
                    />
                </div>
                <div>
                    <SelectId
                        labelField="label"
                        label="Status"
                        name="status"
                        simpleSelect={true}
                        allowBlank={true}
                        value={formState.status || []}
                        onChange={onChange}
                        options={statuses}
                        style={{ flexBasis: '15rem' }}
                    />
                </div>
                <div>
                    <FormControlLabel disabled={formState.years_comparison} control={<Switch name="toggleTop15Campaigns" color="primary" />} label="Top 15 Campaigns" checked={formState.toggleTop15Campaigns} onChange={onChange} />
                </div>
                <div>
                    <FormControlLabel control={<Switch name="years_comparison" color="primary" />} label="YoY Comparison" checked={formState.years_comparison} onChange={onChange} />
                </div>
            </div>
            {renderBodyDashboard}
        </React.Fragment>
    );
}
